import { useState } from "react";

import Slide from "../../ui/Slide";
import HighlightBand from "../../ui/HighlightBand";

import { Album, Container, Content } from "./styles";

import ArenaIbirapueraCard from "../../../assets/images/gallery/cards/arena-ibirapuera.png";
import RealMadridChallengeCard from "../../../assets/images/gallery/cards/real-madrid-challenge.png";
import EspExperienceCard from "../../../assets/images/gallery/cards/esp-experience.png";
import EspSocialCard from "../../../assets/images/gallery/cards/esp-social.png";

import arenaIbirapueraCover from "../../../assets/images/gallery/albums/arena-ibirapuera/cover.jpg";
import arenaIbirapueraPhoto01 from "../../../assets/images/gallery/albums/arena-ibirapuera/photo-01.jpg";
import arenaIbirapueraPhoto02 from "../../../assets/images/gallery/albums/arena-ibirapuera/photo-02.jpg";
import arenaIbirapueraPhoto03 from "../../../assets/images/gallery/albums/arena-ibirapuera/photo-03.jpg";
import arenaIbirapueraPhoto04 from "../../../assets/images/gallery/albums/arena-ibirapuera/photo-04.jpg";
import arenaIbirapueraPhoto05 from "../../../assets/images/gallery/albums/arena-ibirapuera/photo-05.jpg";
import arenaIbirapueraPhoto06 from "../../../assets/images/gallery/albums/arena-ibirapuera/photo-06.jpg";
import arenaIbirapueraPhoto07 from "../../../assets/images/gallery/albums/arena-ibirapuera/photo-07.jpg";
import arenaIbirapueraPhoto08 from "../../../assets/images/gallery/albums/arena-ibirapuera/photo-08.jpg";

import realMadridChallengeCover from "../../../assets/images/gallery/albums/real-madrid-challenge/cover.jpg";
import realMadridChallengePhoto01 from "../../../assets/images/gallery/albums/real-madrid-challenge/photo-01.jpg";
import realMadridChallengePhoto02 from "../../../assets/images/gallery/albums/real-madrid-challenge/photo-02.jpg";
import realMadridChallengePhoto03 from "../../../assets/images/gallery/albums/real-madrid-challenge/photo-03.jpg";
import realMadridChallengePhoto04 from "../../../assets/images/gallery/albums/real-madrid-challenge/photo-04.jpg";
import realMadridChallengePhoto05 from "../../../assets/images/gallery/albums/real-madrid-challenge/photo-05.jpg";
import realMadridChallengePhoto06 from "../../../assets/images/gallery/albums/real-madrid-challenge/photo-06.jpg";
import realMadridChallengePhoto07 from "../../../assets/images/gallery/albums/real-madrid-challenge/photo-07.jpg";
import realMadridChallengePhoto08 from "../../../assets/images/gallery/albums/real-madrid-challenge/photo-08.jpg";
import realMadridChallengePhoto09 from "../../../assets/images/gallery/albums/real-madrid-challenge/photo-09.jpg";
import realMadridChallengePhoto10 from "../../../assets/images/gallery/albums/real-madrid-challenge/photo-10.jpg";

import espExperienceCover from "../../../assets/images/gallery/albums/esp-experience/cover.jpg";
import espExperiencePhoto01 from "../../../assets/images/gallery/albums/esp-experience/photo-01.jpg";
import espExperiencePhoto02 from "../../../assets/images/gallery/albums/esp-experience/photo-02.jpg";
import espExperiencePhoto03 from "../../../assets/images/gallery/albums/esp-experience/photo-03.jpg";
import espExperiencePhoto04 from "../../../assets/images/gallery/albums/esp-experience/photo-04.jpg";
import espExperiencePhoto05 from "../../../assets/images/gallery/albums/esp-experience/photo-05.jpg";
import espExperiencePhoto06 from "../../../assets/images/gallery/albums/esp-experience/photo-06.jpg";
import espExperiencePhoto07 from "../../../assets/images/gallery/albums/esp-experience/photo-07.jpg";
import espExperiencePhoto08 from "../../../assets/images/gallery/albums/esp-experience/photo-08.jpg";

import espSocialCover from "../../../assets/images/gallery/albums/esp-social/cover.jpg";
import espSocialPhoto01 from "../../../assets/images/gallery/albums/esp-social/photo-01.jpg";
import espSocialPhoto02 from "../../../assets/images/gallery/albums/esp-social/photo-02.jpg";
import espSocialPhoto03 from "../../../assets/images/gallery/albums/esp-social/photo-03.jpg";
import espSocialPhoto04 from "../../../assets/images/gallery/albums/esp-social/photo-04.jpg";
import espSocialPhoto05 from "../../../assets/images/gallery/albums/esp-social/photo-05.jpg";
import espSocialPhoto06 from "../../../assets/images/gallery/albums/esp-social/photo-06.jpg";
import espSocialPhoto07 from "../../../assets/images/gallery/albums/esp-social/photo-07.jpg";
import espSocialPhoto08 from "../../../assets/images/gallery/albums/esp-social/photo-08.jpg";

const arenaIbirapueraImages = [
  arenaIbirapueraCover,
  arenaIbirapueraPhoto01,
  arenaIbirapueraPhoto02,
  arenaIbirapueraPhoto03,
  arenaIbirapueraPhoto04,
  arenaIbirapueraPhoto05,
  arenaIbirapueraPhoto06,
  arenaIbirapueraPhoto07,
  arenaIbirapueraPhoto08,
].map((image, index) => ({
  index: index + 1,
  image,
}));

const realMadridChallengeImages = [
  realMadridChallengeCover,
  realMadridChallengePhoto01,
  realMadridChallengePhoto02,
  realMadridChallengePhoto03,
  realMadridChallengePhoto04,
  realMadridChallengePhoto05,
  realMadridChallengePhoto06,
  realMadridChallengePhoto07,
  realMadridChallengePhoto08,
  realMadridChallengePhoto09,
  realMadridChallengePhoto10,
].map((image, index) => ({
  index: index + 1,
  image,
}));

const espExperienceImages = [
  espExperienceCover,
  espExperiencePhoto01,
  espExperiencePhoto02,
  espExperiencePhoto03,
  espExperiencePhoto04,
  espExperiencePhoto05,
  espExperiencePhoto06,
  espExperiencePhoto07,
  espExperiencePhoto08,
].map((image, index) => ({
  index: index + 1,
  image,
}));

const espSocialImages = [
  espSocialCover,
  espSocialPhoto01,
  espSocialPhoto02,
  espSocialPhoto03,
  espSocialPhoto04,
  espSocialPhoto05,
  espSocialPhoto06,
  espSocialPhoto07,
  espSocialPhoto08,
].map((image, index) => ({
  index: index + 1,
  image,
}));

const Gallery = () => {
  const [showAlbum, setShowAlbum] = useState(false);
  const [images, setImages] = useState(arenaIbirapueraImages);

  const handleImages = (albumImages) => {
    setImages(albumImages);
    setShowAlbum(true);
  };

  return (
    <Container>
      <Content>
        <HighlightBand>
          <h1>GALERIA</h1>
        </HighlightBand>

        <div>
          <Album onClick={() => handleImages(arenaIbirapueraImages)}>
            <img src={ArenaIbirapueraCard} alt="imagem" />
            <span>Arena Ibirapuera</span>
          </Album>
          <Album onClick={() => handleImages(realMadridChallengeImages)}>
            <img src={RealMadridChallengeCard} alt="imagem" />
            <span>FRM World Challenge</span>
          </Album>
          <Album onClick={() => handleImages(espExperienceImages)}>
            <img src={EspExperienceCard} alt="imagem" />
            <span>ESP Experience</span>
          </Album>
          <Album onClick={() => handleImages(espSocialImages)}>
            <img src={EspSocialCard} alt="imagem" />
            <span>ESP Social</span>
          </Album>
        </div>

        <Slide
          showAlbum={showAlbum}
          setShowAlbum={setShowAlbum}
          images={images}
        />
      </Content>
    </Container>
  );
};

export default Gallery;
